import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="w-full bg-[#1B2A4A] text-white" aria-label="Introducción" data-id="element-87">
      <div className="max-w-3xl mx-auto px-5 py-12 md:py-20" data-id="element-88">
        {/* Badge */}
        <div className="flex justify-center mb-8" data-id="element-89">
          <span className="inline-block bg-white/10 border border-white/20 text-white/90 text-sm font-semibold px-5 py-2 rounded-full tracking-wide" data-id="element-90">
            Protocolo de 48 Horas
          </span>
        </div>

        {/* Main Headline */}
        <h1 className="text-4xl md:text-6xl font-bold text-center leading-tight mb-4" data-id="element-91">
          Hoy no tienes que aguantar.
        </h1>

        {/* Sub-headline */}
        <p className="text-xl md:text-2xl text-center text-white/80 font-medium mb-12" data-id="element-92">
          48 horas. Un plan. Cero improvisación.
        </p>

        {/* Opening Narrative */}
        <div className="max-w-2xl mx-auto space-y-6 text-lg md:text-xl leading-relaxed text-white/90 mb-12" data-id="element-93">
          <p data-id="element-94">
            Son las 2:00 de la mañana. Te cambias de lado en la cama. Te
            sientas. Te paras. Tomas agua. Te enjuagas. Respiras… y el dolor
            sigue ahí, como si tuviera un interruptor propio.
          </p>
          <p className="text-white font-semibold text-xl md:text-2xl" data-id="element-95">
            Y lo peor no es el dolor.
          </p>
          <p data-id="element-96">
            Lo peor es esa pregunta que se te mete en la cabeza cuando todo está
            oscuro:{' '}
            <em className="text-[#F59E0B] font-semibold" data-id="element-97">
              «¿Y si esto es algo serio?»
            </em>
          </p>
          <p data-id="element-98">
            En ese momento, Google no ayuda. TikTok te confunde. Y tu cuerpo
            solo quiere una cosa: <strong data-id="element-99">alivio y claridad.</strong>
          </p>
          <p className="border-l-4 border-[#10B981] pl-5 py-2 bg-white/5 rounded-r-lg" data-id="element-100">
            <strong data-id="element-101">SOS Muela</strong> es eso: un protocolo simple para las
            próximas 48 horas — para bajar el pánico, evitar errores y tomar
            decisiones claras hasta que te atienda un profesional.
          </p>
        </div>

        {/* Product Mockup */}
        <div className="flex justify-center mb-12" data-id="element-102">
          <img src="https://cdn.magicpatterns.com/uploads/aZtErEZ3tNzrmXkkXV19Me/SOS_muela_Mockup.jpg" alt="SOS Muela - Protocolo de 48 Horas mostrado en teléfono, tablet y laptop" className="w-full max-w-lg rounded-xl shadow-2xl" data-id="element-103" />
        </div>

        {/* CTA */}
        <CTAButton text="Quiero Mi Protocolo" subtitle="Descarga inmediata. PDF listo para imprimir." href="#precio" dark data-id="element-104" />
        <p className="text-center text-white/50 text-xs mt-4" data-id="element-105">
          Pago seguro. Acceso instantáneo.
        </p>
      </div>
    </section>;
}